import React from 'react';
import { useSelector } from 'react-redux';

function Row({ title, value1, value2 }: { title: any; value1?: any; value2: any }) {
  return (
    <li className="flex">
      <span className="flex justify-between min-w-[300px] border-b border-r border-l border-(--ink-50) [&>span]:grow [&>span]:min-w-[150px] [&>span]:py-1 [&>span]:px-2 [&>span:first-child]:border-r [&>span:first-child]:border-(--ink-50)">
        <span>{title}</span>
        {value1 && <span>{value1}</span>}
      </span>
      <span className="py-1 px-2 min-w-[calc(100%-300px)] border-b border-r border-(--ink-50)">
        {value2}
      </span>
    </li>
  );
}

export default function ClassificationDetailList() {
  const { detail } = useSelector((state) => (state as any).classification);

  if (!detail) {
    return null;
  }

  const getTripleColumnRows = Object.keys(detail).map((key) =>
    key.match(/u[0-9]/g) ? (
      <Row key={key} title={key} value1={detail[key].number} value2={detail[key].title} />
    ) : null
  );

  return (
    <ul className="flex flex-col text-(--ink-600) text-[13px]">
      <Row key={11} title="Název" value2={detail.title} />
      {getTripleColumnRows}
      <Row key={12} title="Definuje komponenty?" value2={detail.is_def_component ? 'Ano' : 'Ne'} />
      <Row key={13} title="Definuje skladbu?" value2={detail.is_def_composition ? 'Ano' : 'Ne'} />
    </ul>
  );
}
